// Totals come from all company invoices, without a client-side pagination cap.
export const rateMap = (exchangeRates) => {
  const rates = { MDL: 1 };
  (exchangeRates?.Valute || []).forEach(({ CharCode, Value, Nominal = 1 }) => {
    const value = Number(String(Value).replace(',', '.'));
    const nominal = Number(Nominal);
    if (Number.isFinite(value) && value > 0 && Number.isFinite(nominal) && nominal > 0) {
      rates[CharCode] = value / nominal;
    }
  });
  return rates;
};

export const convertTotals = (totals = {}, rates = { MDL: 1 }) => {
  let sum = 0;
  for (const [currency, amount] of Object.entries(totals)) {
    const value = Number(amount);
    if (!Number.isFinite(value)) return null;
    if (value === 0) continue;
    if (!rates[currency]) return null;
    sum += value * rates[currency];
  }
  return Number.isFinite(sum) ? sum : null;
};

export const monthLabel = (month, locale) => {
  const [year, number] = month.split('-').map(Number);
  // UTC prevents day-one labels moving into the previous month in other zones.
  return new Intl.DateTimeFormat(locale, { month: 'short', timeZone: 'UTC' })
    .format(new Date(Date.UTC(year, number - 1, 1)));
};

export const buildDashboardStats = (summary, exchangeRates, locale = 'ro') => {
  if (!summary) return null;
  const rates = rateMap(exchangeRates);
  const months = summary.months.map((month) => ({
    label: monthLabel(month.month, locale),
    current: convertTotals(month.current, rates),
    previous: convertTotals(month.previous, rates),
  }));
  const currencies = Object.entries(summary.last_30_days.totals).map(([currency, amount]) => ({
    currency,
    amount: convertTotals({ [currency]: amount }, rates),
  }));
  return {
    months,
    yearToDate: convertTotals(summary.year_to_date, rates),
    last30: {
      ...summary.last_30_days,
      currencies,
      total: convertTotals(summary.last_30_days.totals, rates),
    },
    missingRates: months.some(({ current, previous }) => current === null || previous === null) ||
      currencies.some(({ amount }) => amount === null) || convertTotals(summary.year_to_date, rates) === null,
  };
};
